import React, {useContext, useEffect, useState} from 'react';
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '../jwt/_services';
import {StateContext} from "../utils/context";
import {useFetch} from "../utils/fetchHook";
import TenantContext from "../utils/tenantContext";

export const PrivateRoute = ({ component: Component, ...rest }) => {
    const {setCurrentUser} = useContext(StateContext);
    const {tenant} = useContext(TenantContext);

    const token = authenticationService.currentUserValue ? authenticationService.currentUserValue.value : null;
    const [data] = useFetch("GET", "users/", token);

    const [isSubUser, isSubUserSET]  = useState(false);
    const [isAdminUser, isAdminUserSET] = useState(false);
    const [bulkUploadEnabled, bulkUploadEnabledSET]  = useState(false);
    const [canAddInvoices, canAddInvoicesSET] = useState(false);
    const [canAddSubuserInvoices, canAddSubuserInvoicesSET] = useState(false);
    const [canAddAccounting, canAddAccountingSET] = useState(false);
    const [canAddEditMusicLink, canAddEditMusicLinkSET] = useState(false);
    const [canAddEditLinkLandingPage, canAddEditLinkLandingPageSET] = useState(false);
    const [canAddEditSubUser, canAddEditSubUserSET] = useState(false);
    const [canAddPaymentMethod, canAddPaymentMethodSET] = useState(false);
    const [releaseTransferEnabled, releaseTransferEnabledSET] = useState(false);
    const [distributionEnabled, distributionEnabledSET] = useState(false);
    const [promotionsEnabled, promotionsEnabledSET] = useState(false);
    const [artistsEnabled, artistsEnabledSET] = useState(false);
    const [labelsEnabled, labelsEnabledSET] = useState(false);
    const [masteringEnabled, masteringEnabledSET] = useState(false);
    const [copyrightinfringementsEnabled, copyrightinfringementsEnabledSET] = useState(true);
    const [canAddEditEmployeeAccount, canAddEditEmployeeAccountSET] = useState(false);
    const [canViewSLA, canViewSLASET] = useState(false);
    const [canViewUpdateBranding, canViewUpdateBrandingSET] = useState(false);
    const [canOrderDeploymentCredits, canOrderDeploymentCreditsSET] = useState(false);
    const [subuserInvoicesEnabled, subuserInvoicesEnabledSET] = useState(false);

    useEffect(() => {
        if (tenant && tenant.invoices_enabled) {
            subuserInvoicesEnabledSET(true);
        }
    }, [tenant]);

    useEffect(() => {
        if (data.count > 0) {
            const currentUser = data.results[0];
            setCurrentUser(currentUser);
            if(currentUser.is_sub_user)
            {
                isSubUserSET(true);
                copyrightinfringementsEnabledSET(false);
            }
            if(currentUser.is_premium_user || currentUser.is_employee_account) {
                isAdminUserSET(true);
            }
            if(currentUser.bulk_upload)
            {
                bulkUploadEnabledSET(true);
            }
            if(currentUser.artists_accounting)
            {
                canAddAccountingSET(true);
            }
            if(currentUser.music_link)
            {
                canAddEditMusicLinkSET(true);
            }
            if(currentUser.link_in_bio)
            {
                canAddEditLinkLandingPageSET(true);
            }
            if(currentUser.can_add_invoices && currentUser.invoicing_available && currentUser.invoices_generating===0)
            {
                canAddInvoicesSET(true);
            }
            if(currentUser.is_sub_user && currentUser.can_add_invoices && currentUser.invoicing_available && currentUser.invoices_generating===0 && subuserInvoicesEnabled)
            {
                canAddSubuserInvoicesSET(true);
            }
            if(currentUser.is_premium_user)
            {
                if(currentUser.is_employee_account && currentUser.employee_permission === "content_only") {
                    canAddEditSubUserSET(false);
                } else {
                    canAddEditSubUserSET(true);
                }
            }
            if(currentUser.total_payment_methods<=3)
            {
                canAddPaymentMethodSET(true);
            }
            if(currentUser.distribution)
            {
                distributionEnabledSET(true);
            }
            if(currentUser.release_transfer)
            {
                releaseTransferEnabledSET(true);
            }
            if(currentUser.promotions)
            {
                promotionsEnabledSET(true);
            }
            if(currentUser.artists)
            {
                artistsEnabledSET(true);
            }
            if(currentUser.labels_enabled)
            {
                labelsEnabledSET(true);
            }
            if(currentUser.mastering)
            {
                masteringEnabledSET(true);
            }
            if(currentUser.is_premium_user && !currentUser.is_employee_account && currentUser.employee_accounts && currentUser.total_employee_accounts<10)
            {
                canAddEditEmployeeAccountSET(true);
            }
            if(currentUser.is_premium_user || currentUser.is_employee_account)
            {
                canViewSLASET(true);
                canViewUpdateBrandingSET(true);
                canOrderDeploymentCreditsSET(true);
            }
        }
        // eslint-disable-next-line
    }, [data])


    if (!token) {
        authenticationService.logoutNoRefresh();
    }

    const originUrl = window.location.origin;
    const urlPath = window.location.pathname;
    const signUpUrl = originUrl.includes("signup");

    const musicLinkRequest = originUrl.includes("musiclink.io");
    const linkInBioRequest = originUrl.includes("mylnk.io");
    const tokensUrl = urlPath.includes("tokens");
    const subUserUrl = urlPath.includes("sub-users");
    const accountingAddUrl = urlPath.includes("accounting/add");
    const invoicesUrl = urlPath.includes("invoices") && !urlPath.includes("my");
    const invoicesAddUrl = urlPath.includes("invoices/add") && !urlPath.includes("my");
    const subuserInvoicesConfigurationUrl = urlPath.includes("invoice-configuration");
    const subuserInvoicesAdminUrl = urlPath.includes("subuser-invoices");
    const subuserInvoicesUserUrl = urlPath.includes("my-invoices");
    const subUserInvoicesAddUrl = urlPath.includes("my-invoices/add");
    const musicLinkAddEditUrl = urlPath.includes("music-link") && (urlPath.includes("add") || urlPath.includes("update") || urlPath.includes("view-stats"));
    const linkLandingPageAddEditUrl = urlPath.includes("link-landing-page") && (urlPath.includes("add") || urlPath.includes("update") || urlPath.includes("view-stats"));
    const subUsersAddEditUrl = urlPath.includes("sub-users") && (urlPath.includes("add") || urlPath.includes("update"));
    const paymentMethodAddUrl = urlPath.includes("payment-methods/add");
    const distributionUrl = urlPath.includes("releases") && (urlPath.includes("add") || urlPath.includes("update") || urlPath.includes("view") || urlPath.includes("tracks"));
    const releaseTransferUrl = urlPath.includes("releases") && urlPath.includes("transfer");
    const promotionsUrl = urlPath.includes("promotions") && (urlPath.includes("add") || urlPath.includes("update") || urlPath.includes("view"));
    const listsUrl = urlPath.includes("lists") && (urlPath.includes("add") || urlPath.includes("update"));
    const recipientsUrl = urlPath.includes("recipients") && (urlPath.includes("add") || urlPath.includes("update"));
    const featureUrl = urlPath.includes("feature") && urlPath.includes("add");
    const artistsUrl = urlPath.includes("artists") && (urlPath.includes("add") || urlPath.includes("update") || urlPath.includes("view-details"));
    const labelsUrl = urlPath.includes("labels") && (urlPath.includes("add") || urlPath.includes("update"));
    const masteringUrl = urlPath.includes("mastering") && (urlPath.includes("add") || urlPath.includes("update") || urlPath.includes("view") || urlPath.includes("edit-parameters"));
    const copyrightInfringementsUrl = urlPath.includes("copyright-infringements");
    const employeeAccountsAddEditUrl = urlPath.includes("employee-accounts") && (urlPath.includes("add") || urlPath.includes("update"));
    const SLAViewUrl = urlPath.includes("sla");
    const brandingUrl = urlPath.includes("branding");
    const deploymentCreditsUrl = urlPath.includes("deployment-credits");

    return (
        <Route {...rest} render={props => {
            
            if((musicLinkRequest || linkInBioRequest) && !token) {
                window.location.href = "https://motivagroove.com";
            }

            else if (!token) {
                if(signUpUrl) {
                    // Not logged in && SignUp Request so redirect to sign up page with the /return url
                    return <Redirect to={{ pathname: '/authentication/signup', state: { from: props.location } }} />
                }
                else {
                    // Not logged in && Not SignUp Request so redirect to login page with the return url
                    return <Redirect to={{ pathname: '/authentication/login', state: { from: props.location } }} />
                }
            }

            else
            {
                // Not authorized to access Invoicing, Sub-users modules, Invoice Configuration or Subuser Invoices Admin module
                if(isSubUser && (invoicesUrl || subUserUrl || subuserInvoicesAdminUrl || subuserInvoicesConfigurationUrl))
                {
                    return <Redirect to={{ pathname: '/', state: { from: props.location } }} />
                }

                // Subuser user not authorized to access My Invoices module if Subuser Invoices isn't enabled
                if(isSubUser && !subuserInvoicesEnabled && (subuserInvoicesUserUrl || subUserInvoicesAddUrl))
                {
                    return <Redirect to={{ pathname: '/', state: { from: props.location } }} />
                }

                // Admin user not authorized to access My Invoices module (meant for subusers)
                if(isAdminUser && (subuserInvoicesUserUrl || subUserInvoicesAddUrl))
                {
                    return <Redirect to={{ pathname: '/', state: { from: props.location } }} />
                }

                // Not authorized to access Tokens module

                if(!bulkUploadEnabled && tokensUrl)
                {
                    return <Redirect to={{ pathname: '/', state: { from: props.location } }} />
                }

                // Not authorized to access Releases module

                if(!distributionEnabled && distributionUrl)
                {
                    return <Redirect to={{ pathname: '/releases', state: { from: props.location } }} />
                }

                // Not authorized to access Releases Transfer module

                if(!releaseTransferEnabled && releaseTransferUrl)
                {
                    return <Redirect to={{ pathname: '/releases', state: { from: props.location } }} />
                }

                // Not authorized to access Artists module

                if(!artistsEnabled && artistsUrl)
                {
                    return <Redirect to={{ pathname: '/artists', state: { from: props.location } }} />
                }

                // Not authorized to access Labels module

                if(!labelsEnabled && labelsUrl)
                {
                    return <Redirect to={{ pathname: '/labels', state: { from: props.location } }} />
                }

                // Not authorized to access Promotions module

                if(!promotionsEnabled && promotionsUrl)
                {
                    return <Redirect to={{ pathname: '/promotions', state: { from: props.location } }} />
                }

                // Not authorized to access Lists module

                if(!promotionsEnabled && listsUrl)
                {
                    return <Redirect to={{ pathname: '/lists', state: { from: props.location } }} />
                }

                // Not authorized to access Recipients module

                if(!promotionsEnabled && recipientsUrl)
                {
                    return <Redirect to={{ pathname: '/recipients', state: { from: props.location } }} />
                }

                // Not authorized to access Feature Request module

                if(!promotionsEnabled && featureUrl)
                {
                    return <Redirect to={{ pathname: '/feature', state: { from: props.location } }} />
                }

                // Not authorized to Add/Edit Sub-Users

                if(!canAddEditSubUser && subUsersAddEditUrl)
                {
                    return <Redirect to={{ pathname: '/sub-users', state: { from: props.location } }} />
                }

                // Not authorized to Add/Edit Employee Accounts

                if(!canAddEditEmployeeAccount && employeeAccountsAddEditUrl)
                {
                    return <Redirect to={{ pathname: '/employee-accounts', state: { from: props.location } }} />
                }

                // Not authorized to Add Invoices               
                if(!canAddInvoices && invoicesAddUrl)
                {
                    return <Redirect to={{ pathname: '/invoices', state: { from: props.location } }} />
                }

                // Not authorized to Add Subuser Invoices
                if(!canAddSubuserInvoices && subUserInvoicesAddUrl)
                {
                    return <Redirect to={{ pathname: '/my-invoices', state: { from: props.location } }} />
                }

                // Not authorized to Add Accounting                
                if(!canAddAccounting && accountingAddUrl)
                {
                    return <Redirect to={{ pathname: '/accounting', state: { from: props.location } }} />
                }

                // Not authorized to Add/Edit/ViewStats For Music Link And Music Link Url Parts                
                if(!canAddEditMusicLink && musicLinkAddEditUrl)
                {
                    return <Redirect to={{ pathname: '/music-link', state: { from: props.location } }} />
                }

                // Not authorized to Add/Edit For Link Landing Page                
                if(!canAddEditLinkLandingPage && linkLandingPageAddEditUrl)
                {
                    return <Redirect to={{ pathname: '/link-landing-page', state: { from: props.location } }} />
                }

                // Not allowed to Add a new Payment Method                
                if(!canAddPaymentMethod && paymentMethodAddUrl)
                {
                    return <Redirect to={{ pathname: '/payment-methods', state: { from: props.location } }} />
                }

                // Not authorized to access Mastering module

                if(!masteringEnabled && masteringUrl)
                {
                    return <Redirect to={{ pathname: '/mastering', state: { from: props.location } }} />
                }

                // Not authorized to access Copyright Infringements module
                if(!copyrightinfringementsEnabled && copyrightInfringementsUrl)
                {
                    return <Redirect to={{ pathname: '/dashboard', state: { from: props.location } }} />
                }

                // Not authorized to view SLA module
                if(!canViewSLA && SLAViewUrl)
                {
                    return <Redirect to={{ pathname: '/dashboard', state: { from: props.location } }} />
                }

                // Not authorized to view Branding module
                if(!canViewUpdateBranding && brandingUrl)
                {
                    return <Redirect to={{ pathname: '/dashboard', state: { from: props.location } }} />
                }

                // Not authorized to order Deployment Credits module
                if(!canOrderDeploymentCredits && deploymentCreditsUrl)
                {
                    return <Redirect to={{ pathname: '/dashboard', state: { from: props.location } }} />
                }

                else
                {
                    // authorised so return component
                    return <Component {...props} />
                }
            }
        }} />
    )
}

export default PrivateRoute;